import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
@Pipe({ name: 'zipcode' })
export class FormatZipcodePipe implements PipeTransform {
  transform(zipCode: string | undefined) {
    if (!zipCode) {
      return '';
    }

    let result: string;
    if (zipCode !== '' && zipCode !== null && typeof zipCode !== 'undefined') {
      //  Remove everything expect numbers
      zipCode = zipCode.replace(/[^0-9]+/g, '');
      if (zipCode.length > 5) {
        result = zipCode.slice(0, 5) + '-' + zipCode.slice(5);
      }
      if (zipCode.length <= 5) {
        result = zipCode;
      }
    }
    return result;
  }
}
